export default {
    menu: {
        concursos: "Concursos",
        lotes: "Lotes",
        ofertas: "Ofertas",
        licitadores: "Licitadores",
        informes: "Informes"
    },
    buttons: {
        detalles: "Detalles",
        crear: "Crear",
        eliminar: "Eliminar",
        cancelar: "Cancelar",
        aceptar: "Aceptar",
        añadir: "Añadir",
    },
    languages:{
        title: "Idioma",
        spanish: "Español",
        english: "Inglés",
        selected: "Seleccionado"
    },
    user:{
        logout: "Cerrar sesión",
        profile: "Cambiar contraseña",
        account: "Cuenta"
    },
    concursos: {
        nuevo: "Nuevo concurso",
        consultar: "Lista de concursos",
        detalles: "Detalles del concurso"
    },
    lotes: {
        nuevo: "Nuevo lote",
        consultar: "Listado de lotes"
    },
    ofertas: {
        nuevo: "Nueva oferta",
        consultar: "Consultar ofertas"
    },
    licitadores: {
        nuevo: "Nuevo licitador",
        consultar: "Lista de licitadores",
        detalles: "Detalles del licitador"
    },
    informes: {
        nuevo: "Nuevo informe",
        consultar: "Lista de informes"
    },
};